<div class="card card-tabs">
  <div class="card-body">
    <div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
      <label for="" class="title">
        Reportes dinámicos
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="0" checked id="tab0">
      <label for="tab0">
        <i class="fa fa-truck"></i> Venta Proveedor
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="1" id="tab1">
      <label for="tab1">
        <i class="fa fa-user-tag"></i> Venta Cliente
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="2" id="tab2">
      <label for="tab2">
        <i class="fa fa-users"></i> Venta x Cliente
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="3" id="tab3">
      <label for="tab3">
        <i class="fa fa-warehouse"></i> Venta x Proveedor
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="4" id="tab4">
      <label for="tab4">
        <i class="fa fa-boxes-stacked"></i> Inventario x Proveedor
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="5" id="tab5">
      <label for="tab5">
        <i class="fa fa-dollar-sign"></i> Inventario al costo
      </label>
      <input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="6" id="tab6">
      <label for="tab6">
        <i class="fa fa-clock-rotate-left"></i> Cronología
      </label>
    </div>
    <app-provider-sales-month *ngIf="tab == 0"></app-provider-sales-month>
    <app-client-sales-month *ngIf="tab == 1"></app-client-sales-month>
    <app-client-sales *ngIf="tab == 2"></app-client-sales>
    <app-provider-sales *ngIf="tab == 3"></app-provider-sales>
    <app-inventory-provider *ngIf="tab == 4"></app-inventory-provider>
    <app-inventory-cost *ngIf="tab == 5"></app-inventory-cost>
    <app-chronology *ngIf="tab == 6"></app-chronology>
  </div>
</div>
